import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitopunedailycab() {



  const cardData = {


  keyword: "Mumbai to Pune Daily Cabs",

  headingDescription: "Trustline Cab provides reliable Mumbai to Pune daily cab services for regular commuters, corporate employees, business travelers, and professionals who need safe and comfortable transportation every day. Our daily taxi service offers punctual pickups, flexible schedules, experienced chauffeurs, and well-maintained vehicles for hassle-free travel between Mumbai and Pune. Choose from AC Sedans, SUVs, Innova Crysta, Ertiga, and premium vehicles based on your daily travel requirements. With transparent pricing, doorstep pickup, customized packages, easy booking, and 24/7 customer support, Trustline Travels is your trusted partner for Mumbai to Pune daily cab services.",

  topPlaces: [
    {
      title: "EON IT Park Kharadi",
      description: "EON IT Park Kharadi is one of Pune's biggest corporate and technology hubs, housing multinational companies, IT firms, financial organizations, and modern office spaces. It is a major destination for daily corporate commuters traveling from Mumbai."
    },
    {
      title: "Magarpatta City",
      description: "Magarpatta City is a well-planned business township featuring IT parks, corporate offices, residential areas, and lifestyle facilities. It is a preferred destination for professionals requiring regular Mumbai-Pune transportation."
    },
    {
      title: "Pune IT Park",
      description: "Pune IT Park is a commercial destination supporting technology companies, startups, and business organizations. It attracts professionals and corporate employees looking for reliable daily travel solutions."
    },
    {
      title: "Wakad",
      description: "Wakad is a rapidly developing Pune suburb known for residential projects, commercial complexes, restaurants, and excellent connectivity to major IT corridors. It is popular among working professionals and families."
    },
    {
      title: "Aundh",
      description: "Aundh is a premium Pune locality offering corporate offices, educational institutions, hospitals, shopping areas, and modern residential developments. It is a preferred location for professionals and daily commuters."
    },
    {
      title: "Viman Nagar",
      description: "Viman Nagar is a major commercial and residential area near Pune Airport, featuring IT companies, hotels, shopping malls, and business centers. It is frequently used by corporate travelers and professionals."
    },
    {
      title: "Dagdusheth Halwai Ganpati Temple",
      description: "Dagdusheth Halwai Ganpati Temple is one of Pune's most famous cultural landmarks, attracting visitors with its rich heritage, spiritual importance, and grand celebrations."
    },
    {
      title: "Aga Khan Palace",
      description: "Aga Khan Palace is a historic Pune monument known for its beautiful architecture and importance in India's freedom movement. It is a popular sightseeing destination for tourists and history enthusiasts."
    },
    {
      title: "Lonavala",
      description: "Lonavala is a scenic hill station between Mumbai and Pune, famous for waterfalls, valleys, viewpoints, and pleasant weather. It is a popular weekend destination and travel stop on the Mumbai-Pune route."
    },
    {
      title: "Bhushi Dam",
      description: "Bhushi Dam near Lonavala is a famous monsoon attraction known for flowing water, scenic surroundings, and a refreshing atmosphere. It is a popular leisure destination for travelers."
    }
  ],






"services": [
  {
    "name": "Mumbai to Bhosari Cab Service",
    "description": "Book Mumbai to Bhosari Cab Service for comfortable intercity travel with professional drivers, clean AC vehicles, affordable fares, doorstep pickup, and reliable transportation."
  },
  {
    "name": "Mumbai to Camp Pune Cab",
    "description": "Choose Mumbai to Camp Pune Cab for safe and convenient travel with premium cars, experienced chauffeurs, transparent pricing, and flexible booking options."
  },
  {
    "name": "Mumbai to Sinhagad Road Cab",
    "description": "Reserve Mumbai to Sinhagad Road Cab with comfortable vehicles, professional drivers, affordable rates, and smooth highway travel for family and business trips."
  },
  {
    "name": "Mumbai to Hinjewadi Taxi Fare",
    "description": "Check Mumbai to Hinjewadi Taxi Fare with transparent pricing, multiple vehicle choices, fixed rates, and reliable chauffeur-driven service."
  },
  {
    "name": "Mumbai to Wakad Cab",
    "description": "Book Mumbai to Wakad Cab for convenient outstation travel with AC cars, experienced drivers, affordable fares, and timely pickup service."
  },
  {
    "name": "Mumbai to Aundh Daily Cab Fare",
    "description": "Get Mumbai to Aundh Daily Cab Fare for regular travel with comfortable vehicles, professional chauffeurs, economical packages, and reliable daily cab service."
  },
  {
    "name": "Mumbai to Koregaon Park Daily Cab Fare",
    "description": "Choose Mumbai to Koregaon Park Daily Cab Fare service for corporate and personal travel with flexible plans, premium cars, and experienced drivers."
  },
  {
    "name": "Mumbai to Pune Daily Innova Fare",
    "description": "Book Mumbai to Pune Daily Innova Fare service with spacious Innova Crysta vehicles, professional chauffeurs, comfortable seating, and affordable daily travel packages."
  },
  {
    "name": "Mumbai to Pune Daily Ertiga Fare",
    "description": "Get Mumbai to Pune Daily Ertiga Fare with reliable SUV travel, experienced drivers, affordable pricing, and convenient daily transportation."
  },
  {
    "name": "Mumbai to Pune Daily Sedan Cab Fare",
    "description": "Choose Mumbai to Pune Daily Sedan Cab Fare for budget-friendly daily travel with clean vehicles, professional drivers, and comfortable journeys."
  },
  {
    "name": "Mumbai Pune Daily Cab Service",
    "description": "Our Mumbai Pune Daily Cab Service offers regular office travel, corporate transportation, airport trips, and personal journeys with flexible booking options."
  },
  {
    "name": "Mumbai to Pimpri Daily Cab",
    "description": "Book Mumbai to Pimpri Daily Cab for reliable everyday travel with experienced chauffeurs, AC vehicles, affordable fares, and punctual service."
  },
  {
    "name": "Mumbai to Pune Innova Cab",
    "description": "Travel comfortably with Mumbai to Pune Innova Cab featuring spacious seating, premium interiors, professional drivers, and safe highway transportation."
  },
  {
    "name": "Mumbai to Pune AC Cab Service",
    "description": "Choose Mumbai to Pune AC Cab Service for comfortable long-distance travel with well-maintained air-conditioned vehicles and reliable chauffeur service."
  },
  {
    "name": "Mumbai to Pune Daily Taxi Service",
    "description": "Book Mumbai to Pune Daily Taxi Service for regular commuting with flexible schedules, affordable plans, clean vehicles, and professional drivers."
  },
  {
    "name": "Mumbai to Pune Cab Per Km Rate",
    "description": "Check Mumbai to Pune Cab Per Km Rate with transparent fare calculation, multiple vehicle options, and affordable travel packages."
  },
  {
    "name": "Mumbai to Pune Corporate Cab Service",
    "description": "Choose Mumbai to Pune Corporate Cab Service for employee transportation, business meetings, office travel, and professional chauffeur-driven solutions."
  },
  {
    "name": "Mumbai to Pune Airport Cab",
    "description": "Book Mumbai to Pune Airport Cab for reliable airport transfers with timely pickup, luggage assistance, AC vehicles, and experienced drivers."
  },
  {
    "name": "Mumbai to Pune Round Trip Cab",
    "description": "Reserve Mumbai to Pune Round Trip Cab with flexible return timing, affordable fares, premium vehicles, and comfortable travel experience."
  },
  {
    "name": "Mumbai to Pune Cab Fare",
    "description": "Check Mumbai to Pune Cab Fare with transparent pricing, fixed rates, multiple car options, and reliable intercity transportation."
  }
],

"tableData": [
  ["Mumbai to Bhosari Cab Service", "Mumbai to Camp Pune Cab"],
  ["Mumbai to Sinhagad Road Cab", "Mumbai to Hinjewadi Taxi Fare"],
  ["Mumbai to Wakad Cab", "Mumbai to Aundh Daily Cab Fare"],
  ["Mumbai to Koregaon Park Daily Cab Fare", "Mumbai to Pune Daily Innova Fare"],
  ["Mumbai to Pune Daily Ertiga Fare", "Mumbai to Pune Daily Sedan Cab Fare"],
  ["Mumbai Pune Daily Cab Service", "Mumbai to Pimpri Daily Cab"],
  ["Mumbai to Pune Innova Cab", "Mumbai to Pune AC Cab Service"],
  ["Mumbai to Pune Daily Taxi Service", "Mumbai to Pune Cab Per Km Rate"],
  ["Mumbai to Pune Corporate Cab Service", "Mumbai to Pune Airport Cab"],
  ["Mumbai to Pune Round Trip Cab", "Mumbai to Pune Cab Fare"]
],





whychoose: [
  {
    WhyChooseheading: "Reliable Mumbai to Pune Daily Cab Service",
    WhyChoosedescription: "Trustline Cab provides dependable daily cab services between Mumbai and Pune for regular commuters, professionals, and business travelers."
  },
  {
    WhyChooseheading: "Perfect Solution for Regular Travel",
    WhyChoosedescription: "Our daily cab service is designed for passengers who frequently travel between Mumbai and Pune with convenient schedules and comfortable rides."
  },
  {
    WhyChooseheading: "Professional Drivers for Everyday Commute",
    WhyChoosedescription: "Experienced chauffeurs ensure safe, punctual, and stress-free travel while maintaining excellent knowledge of the Mumbai-Pune route."
  },
  {
    WhyChooseheading: "Flexible Vehicle Options",
    WhyChoosedescription: "Choose from Sedan, Ertiga, Innova, Innova Crysta, and other premium vehicles based on your daily travel requirements."
  },
  {
    WhyChooseheading: "Cost-Effective Daily Travel Plans",
    WhyChoosedescription: "Get practical and affordable cab solutions for frequent Mumbai to Pune travel with customized packages according to your needs."
  },
  {
    WhyChooseheading: "Corporate Employee Transportation",
    WhyChoosedescription: "We provide reliable daily transportation solutions for companies, employees, meetings, and regular office travel between both cities."
  },
  {
    WhyChooseheading: "On-Time Pickup & Drop Service",
    WhyChoosedescription: "Our team focuses on punctual pickups and timely drops to help daily travelers maintain their work schedules efficiently."
  },
  {
    WhyChooseheading: "24/7 Travel Assistance",
    WhyChoosedescription: "Receive continuous support for booking changes, travel requirements, and daily cab service coordination anytime."
  }
]

};

const faqData = [
  {
    question: "Does Trustline Cab provide Mumbai to Pune daily cab service?",
    answer: "Yes, Trustline Travels offers daily cab services between Mumbai and Pune for regular commuters, corporate employees, and business travelers."
  },
  {
    question: "Who can use Mumbai to Pune daily cab service?",
    answer: "Daily cab services are ideal for office employees, business professionals, frequent travelers, and companies requiring regular transportation."
  },
  {
    question: "Can I book a fixed daily cab from Mumbai to Pune?",
    answer: "Yes, customized daily cab plans are available according to your preferred pickup timing and travel requirements."
  },
  {
    question: "Which vehicles are available for daily Mumbai Pune travel?",
    answer: "We provide Sedan, Ertiga, Innova, Innova Crysta, and other comfortable vehicles suitable for regular travel."
  },
  {
    question: "Do you provide corporate daily cab services?",
    answer: "Yes, we offer corporate transportation solutions for employee pickup-drop and regular business travel."
  },
  {
    question: "Can I get pickup from my home or office location?",
    answer: "Yes, doorstep pickup and drop facilities are available from residential areas, offices, and preferred locations in Mumbai and Pune."
  },
  {
    question: "Is daily cab service available on weekends and holidays?",
    answer: "Yes, service availability can be arranged according to your travel schedule and requirements."
  },
  {
    question: "Are monthly packages available for regular travelers?",
    answer: "Yes, customized monthly and long-term cab packages are available for frequent Mumbai to Pune commuters."
  },
  {
    question: "Is advance booking required for daily cab service?",
    answer: "Advance planning is recommended to reserve your preferred vehicle and maintain a consistent travel schedule."
  },
  {
    question: "How can I book Mumbai to Pune Daily Cabs with Trustline Travels?",
    answer: "Share your pickup location, travel timing, frequency, passenger details, and vehicle preference to receive a suitable daily cab plan."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sameer Joshi",
    feedback: "Trustline Travels has made my regular Mumbai to Pune commute much easier. The service is punctual, comfortable, and the driver maintains excellent professionalism every day.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Kulkarni",
    feedback: "The daily cab arrangement is reliable and convenient for our office travel. Clean vehicles, timely pickups, and smooth coordination make the journey comfortable.",
    rating: 5
  }
];





  const Images = [
    { place: "/images/keyword/29.jpeg", text: "Pune to Mumbai Cabs", link: "Pune-to-Mumbai-Cabs" },
    { place: "/images/keyword/30.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/31.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
    { place: "/images/keyword/32.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
    { place: "/images/keyword/33.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
    { place: "/images/keyword/34.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
    { place: "/images/keyword/35.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
    { place: "/images/keyword/36.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
    { place: "/images/keyword/37.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
    { place: "/images/keyword/38.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/39.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/40.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
    { place: "/images/keyword/41.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
    { place: "/images/keyword/42.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
    { place: "/images/keyword/43.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
    { place: "/images/keyword/44.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
    { place: "/images/keyword/45.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/46.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/47.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
    { place: "/images/keyword/48.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
    { place: "/images/keyword/49.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
    { place: "/images/keyword/50.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
    { place: "/images/keyword/51.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/52.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/53.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
    { place: "/images/keyword/54.jpg", text: "Boat Club Road to Mumbai Cabs", link: "Boat-Club-Road-to-Mumbai-Cabs" },
    { place: "/images/keyword/55.jpg", text: "Vishrantwadi to Mumbai Cabs", link: "Vishrantwadi-to-Mumbai-Cabs" },
];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Pune Daily Cabs",
  "image": "https://www.trustlinetravels.com/assets/images/mumbai-to-pune-daily-cabs.webp",
  "description":
    "Book Mumbai to Pune Daily Cabs with Trustline Travels for safe, comfortable, and affordable daily taxi services. We offer one-way and round-trip cab services from Mumbai to Pune including Bhosari, Camp, Sinhagad Road, Hinjewadi, Wakad, Aundh, Koregaon Park, Pimpri, and other Pune locations with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Trustline Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.trustlinetravels.com/mumbai-to-pune-daily-cabs"
  }
};




  return (
    <div>
<Helmet>
  <title>Mumbai to Pune Daily Cabs | Daily Taxi Service | +91 8087080034</title>

  <meta
    name="description"
    content="Book Mumbai to Pune Daily Cabs with Trustline Travels for reliable and affordable daily taxi services. Travel comfortably to Bhosari, Camp, Sinhagad Road, Hinjewadi, Wakad, Aundh, Koregaon Park, Pimpri, and all Pune locations with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7."
  />

  <meta
    name="keywords"
    content="mumbai to bhosari cab service, mumbai to camp pune cab, mumbai to sinhagad road cab, mumbai to hinjewadi taxi fare, mumbai to wakad cab, mumbai to aundh daily cab fare, mumbai to koregaon park daily cab fare, mumbai to pune daily innova fare, mumbai to pune daily ertiga fare, mumbai to pune daily sedan cab fare, mumbai pune daily cab service, mumbai to pimpri daily cab, cheapest cab mumbai to pune, mumbai to pune daily cabs"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
  className="wt-bnr-inr site-bg-dark twm-primary-overlay-wrap"
  style={{
    backgroundImage:
      "linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.75) 50%, rgba(0,0,0,0.75) 100%), url('/images/banner-10.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
        <div className="twm-primary-overlay"></div>

        <div className="container">
          <div className="wt-bnr-inr-entry">
            <div className="banner-title-ouer">
              <div className="banner-title-name">
                <h2 className="wt-title">{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid pdfing" >
          <div className="row container-fluid pdfing">
            <div className="col-12 col-md-7 bg-foootr p-0">
              <img src='/images/keyword/17.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Trustline Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              {/* <div id="why-choose-section" className="why-choose-section">


                
                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

               
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div> */}


              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Trustline Cab</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918087080034 " className="pc-call">+91 8087080034 </a>
                      <a href="tel:+919421185217" className="pc-call">+91 9421185217</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918087080034 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+918087080034 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@trustlinetravels.com" className="pc-email">
                      booking@trustlinetravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Trustline Travels</strong><br />
                      Office  No 3 ,Shive Pride, Lane No 14,
                      Swami Samarth Nagar, Sathe Nagar,
                      Lohegaon, Pune, Maharashtra-411047.



                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitopunedailycab;